import Phaser from "phaser";
import { FIGHTERS } from "@circuit/shared";

export class SelectScene extends Phaser.Scene {
  constructor() {
    super("SelectScene");
  }

  create() {
    const root = document.getElementById("ui-root");
    if (!root) return;

    const wrap = document.createElement("div");
    wrap.className = "select-panel interactive";
    const cards = FIGHTERS.map(
      (f) => `
      <button type="button" class="fighter-card" data-testid="fighter-${f.id}" data-fighter="${f.id}">
        <div class="role">${f.role}</div>
        <div class="name">${f.name}</div>
        <div class="tag">${f.tagline}</div>
        <div class="swatch" style="background:#${f.tint.toString(16).padStart(6, "0")}"></div>
      </button>`,
    ).join("");

    wrap.innerHTML = `
      <h2>Pick a fighter</h2>
      <div class="fighter-grid">${cards}</div>
    `;
    root.appendChild(wrap);

    wrap.querySelectorAll(".fighter-card").forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = Number((btn as HTMLElement).dataset.fighter ?? 0);
        this.registry.set("fighterId", id);
        wrap.remove();
        this.scene.start("ArenaScene");
      });
    });
  }
}
